const Terms = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">Terms Of Use</h1>
      </div>
      <div className="flex flex-col gap-6 max-w-[50rem] mx-auto p-[3rem]">
        <p>On this page, you will find a standard version of the TCS Website Terms and Conditions as follows:</p>
        <div className="text-left">
          <h1 className="font-bold text-left sm:text-[25px] text-[20px]">1. TCS Copyright</h1>
          <p>TCS owns all the copyright in this publication</p>
        </div> 
        <div className="text-left">
         <h1 className="font-bold text-left sm:text-[25px]">2. TCS Trademarks</h1>
          <p>
            TCS, TCS Logistics, TCS worldwide Express, TCS sentiments, TCS Connect, TCS Hazir, etc. are trademarks 
            of TCS registered. No other individual or entity has license to use any of these trademarks is given or implied. 
            To download, reproduce, modify, use of these trademarks are strictly prohibited and shall not be copied without 
            prior written permission. Any other trademark referred to in these material are the property of respective owner, 
            TCS does not take any responsibility of their infringement.
          </p>
        </div> 
        <div className="text-left">
         <h1 className="font-bold text-left sm:text-[25px] text-[20px]">3. Authorization to Reproduce</h1>
          <p>
            Any person may reproduce any portion of the material in these web pages subject to the following conditions:
          </p> 
          <li>
            The material shall not be modified in any way and may be used for information and non-commercial purposes only.

          </li>
          <li>Any copied material from this website/page must include the following copyright notice: <span className="font-bold pl-5 underline">Copyright © TCS. All Rights Reserved.</span></li>
        </div>
        <div className="text-left">
         <h1 className="font-bold text-left sm:text-[25px]">4. Use of interactive features on this site</h1>
          <p>
            The interactive features on this site offered by TCS such as access to tracking and user comments. The customers are strictly to
            use for the purposes specified and for no other purposes
          </p>
        </div> 
        <div className="text-left">
          <h1 className="font-bold text-left sm:text-[25px] text-[20px]">5. Limitation of Liability</h1>
          <p>
            TCS or any related party including but not limiting to its affiliates, and any third parties referred/mention on TCS website 
            are not responsible for any incidental, indirect, special, punitive, or consequential damages, loss of profits, lost data 
            loss damages, or business interruption damages resulting from the use or inability to use of TCS website, TCS tracking 
            system or any other content, whether based on warranty, contract, tort, or any other legal theory; , and whether or not 
            TCS has been notified of the possibility of such damages. Without limiting the foregoing, and to the fullest extent 
            permitted by law, customer agree that in no case/event/situation that TCS’s liability for any damages or loss regardless 
            of the form of action shall exceed PKR _______________

          </p>
          </div>
          <div className="text-left">
            <h1 className="font-bold text-left sm:text-[25px] text-[20px]">6. Disclosure of Information</h1>
            <p>
              All information provided to visitors by TCS in these web pages is considered to be confidential and shall 
              not, save as required by law or appropriate regulatory authorities, publish or otherwise disclose or use the 
              same for its own purposes, otherwise than for the provision of services.
            </p>
          </div>
          <div className="text-left">
            <h1 className="font-bold text-left sm:text-[25px] text-[20px]">8. Your Comments</h1>
            <p>
              TCS wants your feedback and appreciates your ideas and suggestions but is unable to answer every comment 
              individually. TCS will be free to use and act on any information you submit as feedback and as suggestion
            </p>
          </div>
      </div>
    </div>
  );
};

export default Terms;
